import type { RefObject } from "react";
import { useMemo } from "react";
import type { PresenceState } from "../../core";
import { usePresence } from "../../react";

export type ConnectionStatus = {
	isEvaluatedDeviceConnected: boolean;
	isScannerDeviceConnected: boolean;
	isPeerScreenActive: boolean;
	isInitialCheckComplete: boolean;
};

function toConnectionStatus(presenceState: PresenceState): ConnectionStatus {
	const isEvaluatedDeviceConnected = presenceState.memberIds.includes("evaluated-device");
	const isScannerDeviceConnected = presenceState.memberIds.includes("scanner-device");
	const peerData = presenceState.memberData["evaluated-device"];
	const isPeerScreenActive = peerData?.screenVisible !== false;

	return {
		isEvaluatedDeviceConnected,
		isScannerDeviceConnected,
		isPeerScreenActive,
		isInitialCheckComplete: presenceState.isInitialCheckComplete,
	};
}

export function useVisionPresence(channelName: string, options?: { shouldManagePresence?: boolean }) {
	const presenceState = usePresence(channelName, options);

	return useMemo(() => toConnectionStatus(presenceState), [presenceState]);
}

export type ConnectionStatusRef = RefObject<ConnectionStatus>;
